<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="4" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <v-btn
              v-if="permisosPresupuestos2 || permisosContabilidadNacional"
              class="mx-1"
              color="primary"
              title="Registrar"
              small
              :disabled="
                form?.detallesSolicitudesPagos?.length ===
                form?.pagosUniversidades?.reduce((acc, item) => acc + item.detallesPagosUniversidades?.length, 0)
              "
              @click="$refs.modalFormularioPagoUniversidadRef.abrir(accionesCrud.REGISTRAR, [])">
              <v-icon>mdi-plus</v-icon>

              Registrar
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver"
              small
              :disabled="item == null"
              @click="$refs.modalMostrarPagoUniversidadRef.abrir(accionesCrud.EDITAR, item)">
              <v-icon>mdi-eye</v-icon>

              Ver
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver Comprobante"
              small
              :disabled="item == null || cargandoComprobante"
              :loading="cargandoComprobante"
              @click="obtenerComprobante(item.id)">
              <v-icon>mdi-file-document</v-icon>

              Ver Comprobante
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mx-1"
                  title="Ver PDF"
                  small
                  :disabled="item == null || cargandoPdf"
                  :loading="cargandoPdf">
                  Ver PDF
                </v-btn>
              </template>

              <v-list>
                <v-list-item link>
                  <v-list-item-title @click="obtenerReportePagoUniversidad(item.id)">
                    <v-icon>mdi-file-pdf</v-icon>

                    Original
                  </v-list-item-title>
                </v-list-item>

                <v-list-item link>
                  <v-list-item-title @click="obtenerReportePagoUniversidad(item.id, true)">
                    <v-icon>mdi-file-pdf</v-icon>

                    UNSXX
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mx-1"
                  title="Ver Todos PDF"
                  small
                  :disabled="items.length === 0 || cargandoTodosPdf"
                  :loading="cargandoTodosPdf">
                  Ver Todos PDF
                </v-btn>
              </template>

              <v-list>
                <v-list-item link>
                  <v-list-item-title @click="() => obtenerReportePagosUniversidades()">
                    <v-icon>mdi-file-pdf</v-icon>

                    Original
                  </v-list-item-title>
                </v-list-item>

                <v-list-item link>
                  <v-list-item-title @click="() => obtenerReportePagosUniversidades(true)">
                    <v-icon>mdi-file-pdf</v-icon>

                    UNSXX
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn
              class="mx-1"
              title="Descargar Excel"
              small
              :disabled="item == null || descargandoExcel"
              :loading="descargandoExcel"
              @click="obtenerExcelPagoUniversidad(item)">
              <v-icon>mdi-file-excel</v-icon>

              Descargar Excel
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoPagosUniversidades ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ModalFormularioPagoUniversidad
          ref="modalFormularioPagoUniversidadRef"
          :nombreRecurso="nombreItem"
          :solicitudPagoId="form.id"
          :monto="form?.monto || 0"
          :detallePlanPagoConceptoUniversidadId="form?.detallePlanPagoConceptoUniversidad?.id"
          :planPagoUniversidadId="
            form?.detallePlanPagoConceptoUniversidad?.planPagoConceptoUniversidad?.planPagoUniversidad?.id
          "
          :universidadId="form?.programaUniversidad?.sedeUniversidad?.universidadId"
          @actualizarListado="actualizarListado" />

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />

        <ModalMostrarPagoUniversidad
          ref="modalMostrarPagoUniversidadRef"
          :nombreRecurso="nombreItem"
          :monto="form?.monto || 0"
          @actualizarListado="listar" />

        <ModalVerPdf ref="modalVerPdfRef" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import ListadoPagosUniversidades from './ListadoPagosUniversidades.vue';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import PagoUniversidadService from '../services/pago-universidad.service';
import ModalFormularioPagoUniversidad from './ModalFormularioPagoUniversidad.vue';
import ListadoItem from './ListadoItem.vue';
import ModalMostrarPagoUniversidad from './ModalMostrarPagoUniversidad.vue';
import ModalVerPdf from './ModalVerPdf.vue';
import PagoUniversidadReporteService from '../services/pago-universidad-reporte.service';
import { mapGetters } from 'vuex';
import { concatenar, formatearValorAMoneda } from '../utils/funciones';
import PagoUniversidadExcelService from '../services/pago-universidad-excel.service';

export default {
  name: 'ModalPagosUniversidades',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoPagosUniversidades,
    ModalFormularioPagoUniversidad,
    ListadoItem,
    ModalMostrarPagoUniversidad,
    ModalVerPdf,
  },
  data() {
    return {
      nombreItem: 'Pago Universidad',
      cargandoPdf: false,
      cargandoTodosPdf: false,
      cargandoComprobante: false,
      descargandoExcel: false,
    };
  },
  computed: {
    listado() {
      return [
        {
          nombre: 'N° Solicitud / Fecha Solicitud',
          valor: `${this.form.numeroSolicitud} / ${this.form.fechaSolicitud}`,
        },
        { nombre: 'Programa Universidad', valor: this.form.programaUniversidad?.programaNombre },
        {
          nombre: 'Sede Universidad',
          valor: this.form.programaUniversidad?.sedeUniversidad?.nombre,
        },
        {
          nombre: 'N° de Cuota / Concepto',
          valor: `${this.form.detallePlanPagoConceptoUniversidad?.numeroCuota} / ${this.form?.detallePlanPagoConceptoUniversidad?.planPagoConceptoUniversidad?.conceptoUniversidad?.concepto?.nombre}`,
        },
        { nombre: 'Monto', valor: formatearValorAMoneda(this.form.monto) },
        { nombre: 'N° Estudiantes', valor: this.form.detallesSolicitudesPagos?.length },
        {
          nombre: 'Monto Total',
          valor: formatearValorAMoneda((this.form.monto * this.form.detallesSolicitudesPagos?.length).toFixed(2)),
        },
        { nombre: 'Solicitado por', valor: this.form.nombreSolicitante },
      ];
    },
    ...mapGetters({
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosContabilidadNacional: 'pago/permisosContabilidadNacional',
    }),
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        numeroSolicitud: null,
        programaUniversidad: null,
        conceptoUniversidadId: null,
        conceptoUniversidad: null,
        monto: null,
        fechaSolicitud: null,
        nombreSolicitante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        solicitanteId: this.$store.state.DATA_USER.id,
        sedeId: this.$store.state?.cargo_sede?.sede?.id,
        sede: null,
        detallesSolicitudesPagos: [],
        pagosUniversidades: [],
        detallePlanPagoConceptoUniversidad: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        numeroSolicitud: data.numeroSolicitud,
        programaUniversidad: data.programaUniversidad,
        conceptoUniversidadId: data.conceptoUniversidadId,
        conceptoUniversidad: data.conceptoUniversidad,
        monto: data.monto,
        fechaSolicitud: data.fechaSolicitud,
        nombreSolicitante: data.nombreSolicitante,
        solicitanteId: data.solicitanteId,
        sedeId: data.sedeId,
        sede: data.sede,
        detallesSolicitudesPagos: data.detallesSolicitudesPagos,
        pagosUniversidades: data.pagosUniversidades,
        detallePlanPagoConceptoUniversidad: data.detallePlanPagoConceptoUniversidad,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      const params = {
        solicitudPagoId: this.form.id,
      };

      this.obtenerDatosConNotificacion(PagoUniversidadService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async obtenerReportePagoUniversidad(pagoId, v2 = false) {
      const params = {
        formato: 'base64',
      };

      this.cargandoPdf = true;

      let response = null;

      try {
        if (v2) {
          response = await PagoUniversidadReporteService.findOneV2(pagoId, { params });
        } else {
          response = await PagoUniversidadReporteService.findOne(pagoId, { params });
        }

        const data = response.data;
        const datos = data?.datos;
        const mensaje = data?.mensaje;
        const base64 = datos;
        const pdf = `data:application/pdf;base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(pdf);
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.base64 = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el reporte',
          type: 'error',
        });
      } finally {
        this.cargandoPdf = false;
      }
    },
    async obtenerReportePagosUniversidades(v2 = false) {
      const params = {
        formato: 'base64',
      };
      const solicitudPagoId = this.form.id;

      this.cargandoTodosPdf = true;

      let response = null;

      try {
        if (v2) {
          response = await PagoUniversidadReporteService.findAllPorSolicitudPagoIdV2(solicitudPagoId, { params });
        } else {
          response = await PagoUniversidadReporteService.findAllPorSolicitudPagoId(solicitudPagoId, { params });
        }

        const data = response.data;
        const datos = data?.datos;
        const mensaje = data?.mensaje;
        const base64 = datos;
        const pdf = `data:application/pdf;base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(pdf);
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.base64 = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el reporte',
          type: 'error',
        });
      } finally {
        this.cargandoTodosPdf = false;
      }
    },
    async obtenerComprobante(pagoId) {
      this.cargandoComprobante = true;

      try {
        const { data } = await PagoUniversidadService.findOneComprobante(pagoId);
        const { datos, mensaje } = data;
        const base64 = datos.file64;
        const archivo = `data:${datos.mimetype};base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(archivo);

        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el comprobante',
          type: 'error',
        });
      } finally {
        this.cargandoComprobante = false;
      }
    },
    actualizarListado() {
      this.listar();
      this.$emit('actualizarListado');
    },
    async obtenerExcelPagoUniversidad(pago) {
      if (!pago) {
        return;
      }

      this.descargandoExcel = true;

      try {
        const { data } = await PagoUniversidadExcelService.findOne(pago.id);
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        const nombreExcel =
          `${this.form.programaUniversidad.codigo}_${this.form.programaUniversidad.programaNombre}_Comprobante_${pago.numeroComprobante}`
            .toUpperCase()
            .split(' ')
            .join('_');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', nombreExcel);
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: 'Descarga exitosa',
          type: 'success',
        });
      } catch (error) {
        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Error al descargar el archivo',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
  },
};
</script>
